import { useMemo as a, useState as O, useEffect as R, useRef as r } from "react";
import { r as d } from "../../../floating-ui.react-SmaXvp4L.js";
const E = (l, n, e, t, i = 0) => {
  const s = a(
    () => !!(n && ["menu", "listbox"].includes(n)),
    [n]
  ), f = a(() => s ? e == null ? void 0 : e.focusItemOnOpen : !1, [e == null ? void 0 : e.focusItemOnOpen, s]), [o, u] = O(null);
  R(() => {
    l.open ? u(f ? i : null) : u(null);
  }, [l.open, f, i]);
  const c = r([]), v = r(null), I = d(l, {
    ...e,
    activeIndex: o,
    enabled: s,
    focusItemOnHover: !1,
    listRef: c,
    loop: n === "menu",
    onNavigate: (m) => {
      u(m), t == null || t(m);
    },
    virtualItemRef: v
  });
  return {
    activeIndex: o,
    list: c,
    listNav: I,
    setActiveIndex: u
  };
};
export {
  E as usePopoverNavigation
};
